import { render, staticRenderFns } from "./SiteMemberAvatar.vue?vue&type=template&id=c981b95e&"
import script from "./SiteMemberAvatar.vue?vue&type=script&lang=js&"
export * from "./SiteMemberAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports